import { createContext, PropsWithChildren, useState } from "react";

interface ITabsContext {
    currentTab: string | number | undefined;
    setCurrentTab: (tab: string | number) => void;
}

export const TabsReactContext = createContext<ITabsContext>({ currentTab: undefined, setCurrentTab: () => {} });

interface ITabsContextProps {
    initialValue?: string | number;
}

export const TabsContext = ({ children, initialValue }: PropsWithChildren<ITabsContextProps>) => {
    const [currentTab, setCurrentTab] = useState<string | number | undefined>(initialValue);

    return <TabsReactContext.Provider value={{ currentTab, setCurrentTab }}>{children}</TabsReactContext.Provider>;
};
